import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormCategoryStringController',
            IssueFormCategoryStringController
        );

    function IssueFormCategoryStringController() {
        var vm = this;

        init();

        function init() {}
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/category_string/issue_form_category.controller.ts